module.exports = __webpack_public_path__ + "img/interests2.21558f92.png";